module.exports = __webpack_public_path__ + "03_face.2e403d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/03_face.png
// module id = NaVW
// module chunks = 0